import React, { useEffect, useState } from "react"
import Presentation from "./Presentation"
import { uploadToStorage } from "../../../../../../shared/fileUploader"
import { connect } from "react-redux"
import {  checkName, editClientDetails } from "../../../../middleware"

function Container(props) {
  const { client, editClientDetails,_check_name,businessInformation } = props
  const [state, setState] = useState({
    businessDisplayName: "",
    businessName: "",
    category: "",
    contactNumber: "",
    email: "",
    fax: "",
    federalId: "",
    jobTerminationNotice: "",
    netTerms: "",
    website: "",
    logo: "",
    busineesNameHelperText:""
  })

  const [isUploading, setIsUploading] = useState(false)

  useEffect(() => {
    const tempState = {}
    Object.entries(client).forEach(([key, value]) => {
			if (state.hasOwnProperty(key)) {
				tempState[key] = value
			}
    })
    console.log(tempState)
    setState((state) => ({ ...state, ...tempState }))
  }, [client])

  const handleSubmit = (e) => {
    e.preventDefault()
    editClientDetails(state)
  }

  const handleFile = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0]
      fileUpload(file)
    }
  }

  const fileUpload = async (file) => {
    const fileName = ["Clientlogo", "_", new Date().toISOString()].join("")
    const filePath = `Clients/${fileName}`
    setIsUploading(true)
    uploadToStorage(file, filePath, fileName, "profilePic")
      .then((url) => {
        console.log(url)
        setState((state) => ({ ...state, logo: url }))
        setIsUploading(false)
      })
      .catch((err) => {
        console.error(err)
        setIsUploading(false)
      })
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    if (e.target.name === "businessName"){
      _check_name(e.target.value)
    }
    setState((prevState) => {
      return {
        ...prevState,
        [name]: value,
      }
    })
  }

  return (
    <div>
      <Presentation
        state={state}
        businessInformation={businessInformation}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        handleFile={handleFile}
        isUploading={isUploading}
      />
    </div>
  )
}
const mapStateToProps = (state, ownProps) => {
  return {
    businessInformation: state.client.newClient.businessInformation,
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    editClientDetails: (payload) => {
      dispatch(editClientDetails(payload, ownProps.client.id))
    },
    _check_name: (name) => {
      dispatch(checkName(name))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)
